import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FaRegCommentAlt } from "react-icons/fa";
import { ModalStatusErro } from "../ModalStatusErro";

interface IProps {
  observacao: string;
  dataSolicitacao: Date;
  acao: string;
}

export function IconeErro({ observacao, dataSolicitacao, acao }: IProps) {
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const iconRef = useRef<HTMLSpanElement>(null);

  const handleMouseEnter = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setCoords({ top: rect.top, left: rect.left + window.scrollX });
    }
    setShow(true);
  };

  return (
    <span
      ref={iconRef}
      style={{ display: "inline-flex" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
    >
      <FaRegCommentAlt
        size={14}
        color="#999"
        style={{ cursor: "pointer", flexShrink: 0 }}
      />
      {show &&
        createPortal(
          <ModalStatusErro
            show={show}
            coords={coords}
            dados={{ dataSolicitacao, tipo: acao, mensagem: observacao }}
          />,
          document.body,
        )}
    </span>
  );
}
